import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "userDashboard" }
const _hoisted_2 = { class: "userProfileData" }
const _hoisted_3 = { class: "consents" }
const _hoisted_4 = { class: "verificationStatus" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_check-round icon" }, null, -1)
const _hoisted_6 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_Button = _resolveComponent("Button")!
  const _component_SidebarUserWrapper = _resolveComponent("SidebarUserWrapper")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SidebarUserWrapper, {
      title: _ctx.$t('user.my_consents'),
      sidebarComponent: _ctx.sidebarComponent
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("ul", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.consents, (consent, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, [
                  _createVNode(_component_InputSwitch, {
                    modelValue: consent.value,
                    "onUpdate:modelValue": ($event: any) => ((consent.value) = $event)
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                  _createElementVNode("h3", null, _toDisplayString(consent.permission_type_id.name), 1),
                  _createElementVNode("span", null, _toDisplayString(consent.permission_type_id.description), 1)
                ]))
              }), 128))
            ])
          ]),
          _createVNode(_component_Button, {
            class: "defaultButton whiteBG",
            label: _ctx.$t(`global.save_changes`),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateConsents()))
          }, null, 8, ["label"])
        ])
      ]),
      _: 1
    }, 8, ["title", "sidebarComponent"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.showUpdateSuccessfulDialog,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showUpdateSuccessfulDialog) = $event)),
      class: "successDialog"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("consents.successful")), 1)
        ]),
        _createElementVNode("button", {
          "event-name": "saveChangesButtonClick",
          "event-from": "/user/my-consents",
          class: "defaultButton",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showUpdateSuccessfulDialog = false))
        }, _toDisplayString(_ctx.$t("dialog.close")), 1)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}